// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/******************************************************************************/
/* New Dashboard */

.column-area {
    margin: 25px 0;
}

/*@media (max-width: 1024px) {*/
/*    .column-area {*/
/*        max-width: 100%*/
/*    }*/
/*}*/

.column-area .cart {
    background: #ffffff;
    border: 1px solid #f8f8f8;
    border-radius: 8px;
    padding: 0 20px 30px 20px;
    text-align: center;
    height: 100%;
}

.column-area .cart .cart-inner {
    height: 132px;
    display: flex;
    align-items: flex-end;
    justify-content: center;
}

.column-area .cart .cart-inner svg {
    position: absolute;
    top: -32px;
    right: -13px;
}

.column-area .cart h6 {
    /*font-weight: 700;*/
    font-weight: 400;
    font-size: 16px;
    text-align: center;
    color: #0f062b;
    margin-top: 15px;
}

.column-area .cart a.goto {
    font-weight: 700;
    font-size: 16px;
    /*color: #7a2df9;*/
    color: #878395;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: -moz-fit-content;
    width: fit-content;
    margin: 15px auto 0;
}

.column-area .cart a.goto span {
    font-size: 17px;
    padding-top: 1px;
}

.column-area .cat-main {
    text-align: center;
    height: 100%;
}

.column-area .cat-main img {
    position: relative;
    z-index: 1;
    /* bottom: -20px; */
}

.column-area .cat-main .cat-text {
    background: #ffffff;
    border: 1px solid #f8f8f8;
    /*box-shadow: 0 4px 22px rgba(171, 171, 171, 0.25);*/
    border-radius: 9px;
    padding: 30px 20px 20px 20px;
    position: relative;
    top: -20px;
}

.column-area .cat-main .cat-text h6 {
    font-weight: 400;
    /*font-size: 20px;*/
    font-size: 14px;
    text-align: center;
    color: #0f062b;
}

.profile-cursor {
    cursor: pointer;
}

.column-area .cat-main .cat-text .btn-area {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
    margin-top: 15px;
}

.column-area .cat-main .cat-text .btn-area button {
    border: none;
    font-weight: 400;
    /*font-size: 18px;*/
    font-size: 14px;
    color: #878395;
    padding: 2px 8px;
    background-color: transparent;
    transition: 0.5s;
}

.column-area .cat-main .cat-text .btn-area button.active,
.column-area .cat-main .cat-text .btn-area button:hover {
    color: #6c2fbb;
}

.column-area .myvideo {
    font-weight: 700;
    font-size: 28px;
    color: #0f062b;
    padding: 5px 0 20px;
    margin-bottom: 0;
}

.column-area .profiles-area .tabs-main {
    background: #ffffff;
    border: 1px solid #f8f8f8;
    border-radius: 16px;
    padding: 15px;
}

.column-area .myvideo {
    font-weight: 700;
    font-size: 28px;
    color: #0f062b;
    padding: 5px 0 20px;
    margin-bottom: 0;
}

.tab-menu ul {
    margin: 0 0 5px 0;
    padding: 0;
    list-style: none;
    display: flex;
    align-items: center;
    gap: 20px;
    overflow-x: auto;
    white-space: nowrap;
}

.tab-menu ul::-webkit-scrollbar {
    height: 7px;
}

.tab-menu ul li a {
    text-decoration: none;
    font-weight: 500;
    font-size: 20px;
    color: #878395;
    padding: 9px 0;
    /* border-radius: 4px; */
}

.tab-menu ul li {
    margin-bottom: 5px;
    margin-right: 20px;
    padding: 10px 0;
}

.tab-menu ul li a.active-a {
    color: #6c2fbb;
    position: relative;
    border-top: 3px solid rgba(108, 47, 187, 1);
    padding: 9px 0;
}

/* .tab-menu ul li a.active-a::before {
  position: absolute;
  bottom: -5px;
  left: 50%;
  transform: translateX(-50%);
  content: "";
  width: 100%;
  height: 3px;
  background: #6c2fbb;
  border-radius: 6px;
} */

/*.tab {*/
/*display: none;*/
/*}*/

.FF-scroll-modify {
    /*max-height: calc(100vh - 580px) !important;*/
    height: 100% !important;
    overflow-x: hidden;
    overflow-y: scroll;
    margin-top: 20px;
}

.FF-scroll-modify-h {
    /*max-height: calc(100vh - 290px) !important;*/
    height: 100% !important;
}

.view-all {
    text-align: right;
    margin-top: -2rem;
}

.no-videos {
    text-align: center;
    margin-top: 15vh;
}

.tab .cartina img {
    /*border-radius: 8px;*/
    height: 100%;
    /*width: 100%;*/
}

.tab .cartina .img-box img {
    /*object-fit: cover;*/
    object-fit: fill;
}

.tab .cartina .img-box {
    overflow: hidden;
    border-radius: 10px;
    max-width: 490px;
    width: 100%;
    height: 260px;
    text-align: center;
    position: relative;
}

/*.tab .cartina .badge-box {*/
/*    height: 190px;*/
/*}*/

.tab .cartina h3 {
    /*font-weight: 700;
      font-size: 20px;*/
    font-weight: 500;
    font-size: 16px;
    color: #0f062b;
    margin: 10px 0 1px 0;
}

.tab .cartina p {
    font-weight: 400;
    font-size: 14px;
    color: #878395;
    margin-bottom: 0;
}

/*.tab-active {*/
/*    display: block;*/
/*}*/

.profile-box-main {
    background: #ffffff;
    border: 1px solid #f8f8f8;
    border-radius: 16px;
    padding: 25px;
    text-align: center;
    height: 100%;
}

.profile-box-main .box {
    position: relative;
    width: -moz-fit-content;
    width: fit-content;
    margin: auto;
    border-radius: 13px;
}

.profile-box-main .box .prof {
    border-radius: 13px;
    width: 82px;
    height: 82px;
    object-fit: cover;
}

.profile-image {
    width: 84px;
    height: 84px;
    text-align: center;
    color: #ffffff;
    background: #bd50d0;
    border-radius: 16px;
    /*display: inline-block;*/
    font-size: 36px;
    font-weight: 600;
    vertical-align: middle;
    text-transform: uppercase;
    line-height: 1.7;
}

.profile-box-main .box .edit {
    position: absolute;
    bottom: -1px;
    right: -12px;
    content: "";
    width: 27px;
    height: 27px;
    background: transparent;
    border-radius: 6px;
    border: none;
    overflow: hidden;
    padding: 0;
}

.profile-box-main h4 {
    font-weight: 500;
    font-size: 16px;
    color: #0f062b;
    margin-top: 20px;
}

.profile-box-main .word {
    font-weight: 400;
    font-size: 14px;
    color: #595469;
    margin-top: 16px;
    /*line-break: anywhere;*/
    word-break: break-word;
}

.profile-box-main .ul {
    gap: 35px;
    margin-top: 30px;
    /*flex-wrap: wrap;*/
}

.profile-box-main .ul h3 {
    font-weight: 700;
    font-size: 24px;
    color: #0f062b;
    margin-bottom: 0;
}

.profile-box-main .ul p {
    font-weight: 500;
    font-size: 14px;
    color: #878395;
    margin-bottom: 0;
}

.profile-box-main .profile-count:hover p {
    text-decoration: underline;
}

.profile-box-main .btn-mania {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 10px;
    max-width: 360px;
    margin: 30px auto 0;
}

/*.profile-box-main .btn-mania button {
  font-weight: 500;
  font-size: 12px;
  color: #6c2fbb;;
  border: 0.5px solid #6c2fbb;
  background: #FFFFFF;
  padding: 4px 12px;
  border-radius: 12px;
  white-space: nowrap;
}*/

.profile-box-main .btn-mania button {
    color: #6c2fbb;
    border: 1px solid #6c2fbb;
    padding: 4px 12px;
    font-size: 12px;
    font-weight: 500;
    background: #FFFFFF;
    border-radius: 11px;
    /*margin: 5px 7px;*/
    white-space: nowrap;
}

/*
.profile-box-main .btn-mania button:nth-child(4n+1) {
  background-color: #f92d82;
}
.profile-box-main .btn-mania button:nth-child(4n+2) {
  background-color: #f99b2d;
}
.profile-box-main .btn-mania button:nth-child(4n+3) {
  background-color: #11d200;
}
.profile-box-main .btn-mania button:nth-child(4n+4) {
  background-color: #2f50ff;
}
*/

.profile-box-main .last-p {
    font-weight: 400;
    font-size: 14px;
    color: #0f062b;
    margin-top: 10px;
    margin-bottom: 0;
}

@media (max-width: 1800px) {
    .column-area .cart h6 {
        font-size: 16px;
    }

    .column-area .cart {
        padding: 0 10px 20px 10px;
    }

    .column-area .cat-main .cat-text h6 {
        font-size: 14px;
    }

    .column-area .cat-main .cat-text .btn-area button {
        /*font-size: 17px;*/
        font-size: 14px;
    }

    .column-area .cat-main .cat-text {
        padding: 20px;
    }

    .column-area .cat-main .cat-text .btn-area {
        margin-top: 10px;
    }

    .tab .cartina .img-box {
        height: 230px;
    }
    /*.tab .cartina .badge-box {*/
    /*    height: 180px;*/
    /*}*/
}

@media (max-width: 1600px) {
    .column-area .cart h6 {
        font-size: 18px;
    }

    .column-area .cat-main .cat-text {
        /*padding: 20px 20px 15px 20px;*/

        padding: 30px 20px 15px 20px;
    }

    .tab .cartina .img-box {
        height: 200px;
    }

    /*.tab .cartina .badge-box {*/
    /*    height: 160px;*/
    /*}*/
}

@media (max-width: 1500px) {
    .tab .cartina .img-box {
        height: 200px;
    }

    .tab .cartina .img-box {
        height: 160px;
    }

    .column-area .cart h6 {
        font-size: 18px;
    }

    .column-area .cart a.goto {
        font-size: 15px;
    }

    .tab-menu ul li a.active-a {
        font-size: 18px;
    }

    .tab-menu ul li a {
        font-size: 18px;
    }
}

@media (max-width: 1300px) {
    .profile-box-main .ul {
        gap: 20px;
    }

    .profile-box-main .ul h3 {
        font-size: 22px;
    }

    .tab .cartina .img-box {
        height: 180px;
    }

    /*.tab .cartina .badge-box {*/
    /*    height: 140px;*/
    /*}*/
}

@media (max-width: 991px) {
    .tab-menu ul {
        margin-bottom: 0;
        gap: 10px;
    }

    .tab .cartina .img-box {
        height: 230px;
    }

    .tab .cartina .badgebadgeba-box-box {
        height: 180px;
    }
}

@media (max-width: 768px) {
    .profile-box-main .btn-mania {
        margin: 20px auto 0;
    }
}

@media (max-width: 425px) {
    .column-area .myvideo {
        font-size: 28px;
        padding: 19px 0;
        margin-bottom: 0;
    }

    .profile-box-main .ul {
        margin-top: 20px;
    }

    .tab .cartina .img-box {
        height: 192px;
    }

    /*.tab .cartina .badge-box {*/
    /*    height: 152px;*/
    /*}*/
}

@media (max-width: 320px) {
    .tab .cartina h3 {
        font-size: 19px;
        margin: 12px 0 0px 0;
    }
}

/*****************************/
.img-poster {
    width: 100%;
    /*margin-top: 10px;*/
}

.slises {
    margin-top: 10px;
    font-size: 14px;
    color: #9e9e9e;
}


.dottype {
    display: inline-block;
    position: absolute;
    left: 0;
    top: 5px;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    /*margin-right: 0;*/
    background: #000;
    vertical-align: middle;
    margin-right: 5px;
    font-weight: 600;
}

.upli.upli0 {
    font-weight: bold;
}

/*.tbalesa {*/
/*  width: 100%;*/
/*  display: table;*/
/*}*/

.dottype.dottype0 {
    background: #A649C7;
}

.dottype.dottype1 {
    background: #EFB43A;
}

.dottype.dottype2 {
    background: #3DC99C;
}

.dottype.dottype3 {
    background: #DB6A8E;
}

.v-choice-info ul li {
    list-style-type: none;
    font-size: 13px;
    position: relative;
    /*background: #f4f7f6;*/
}

.v-choice-info ul li p {
    margin: 0px 10px;
}


p.main-title {
    color: #fff !important;
    position: absolute;
    /*top: 10px;*/
    top: 0;
    /*left: 10px;*/
    left: 0;
    text-align: start;
    width: 100%;
    background: rgba(0, 0, 0, 0.5);
    padding: 3px 8px;
    z-index: 9;
    font-weight: 400 !important;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.view-all a {
    color: #6c2fbb !important;
    font-weight: 500;
    font-size: 12px;
}

/********************/


.slider .owl-nav button.owl-next,
.slider .owl-nav button.owl-prev {
    padding: 0px 8px !important;
}

.slider > .owl-nav button:first-child {
    left: -15px;
}

.slider > .owl-nav button:last-child {
    right: -15px;
}

.v-choice-info {
    padding-top: 12px;
}

.slider .v-choice-info .lr-arrow a {
    position: unset;
    opacity: 1;
    border: 2px solid #727272;
    width: 20px;
    height: 20px;
    border-radius: 2px;
}

.slider .v-choice-info .lr-arrow {
    float: right;
    display: flex;
    justify-content: space-between;
    width: 45px;
}

.v-choice-info .carousel-control-prev-icon {
    background-image: url('left-arrow.svg');
    width: 12px;
    height: 12px;
}

.v-choice-info .carousel-control-next-icon {
    background-image: url('right-arrow.svg');
    width: 12px;
    height: 12px;
}

.v-choice-info .media img {
    width: 40px;
    height: 40px;
}

.hb-film-sec-4 .v-choice-info ul {
    padding-left: 0px;
    margin-bottom: 0;
}

.hb-film-sec-4 .v-choice-info ul li {
    list-style-type: none;
    font-size: 13px;
    background: #f4f7f6;
}

.tbalesa3 {
    padding: 10px !important;
    background: #f4f7f6;
    z-index: 9;
    margin-left: 65px;
}

.v-choice-info > span {
    color: #929090;
    font-size: 14px;
}

.v-choice-info .media .media-body > h6 {
    margin-bottom: 0px;
    font-size: 15px;
}

.slider .carousel-indicators .active {
    background-color: #6c2fbb;
}

.slider .carousel-caption {
    text-align: left;
    left: 0px;
    top: 0px;
    padding-top: 10px;
    padding-left: 13px;
    font-size: 14px;
    font-weight: 600;
}

.slider .v-choice-info ul li samp {
    margin-right: 2px;
    margin-left: 3px;
}

.btn-holder {
    /*float: right;*/
    /*width: auto;*/
    background-color: #FFF;
    color: #6c2fbb;
    border: 1px solid #6c2fbb;
    border-radius: 5px;
    padding: 2px 10px;
}

.btn-holder.follow {
    background-color: #6c2fbb;
    color: #fff;
    border: 1px solid #fff;
}

.over {
    right: 34px !important;
}

.Popular {
    background: #e1e1f9;
    border-radius: 20px;
    border: none;
    outline: none;
    color: #6438b4;
    padding: 5px 15px;
    margin: 0 10px;
    font-weight: bold;
    font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/new-public-profile/new-public-profile.component.css"],"names":[],"mappings":"AAAA,+EAA+E;AAC/E,kBAAkB;;AAElB;IACI,cAAc;AAClB;;AAEA,+BAA+B;AAC/B,qBAAqB;AACrB,0BAA0B;AAC1B,QAAQ;AACR,IAAI;;AAEJ;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,uBAAkB;IAAlB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,oDAAoD;IACpD,kBAAkB;IAClB,4BAA4B;IAC5B,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,2CAA2C;IAC3C,cAAc;AAClB;;AAEA;;;;;;;;;;GAUG;;AAEH,SAAS;AACT,iBAAiB;AACjB,IAAI;;AAEJ;IACI,8CAA8C;IAC9C,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,8CAA8C;IAC9C,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,6BAA6B;AAC7B,qBAAqB;AACrB,IAAI;;AAEJ;IACI;uBACmB;IACnB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA,gBAAgB;AAChB,sBAAsB;AACtB,IAAI;;AAEJ;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,uBAAkB;IAAlB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;;;;;;;;EASE;;AAEF;IACI,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;;;;;;;;;;;;CAaC;;AAED;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;IACA,6BAA6B;IAC7B,qBAAqB;IACrB,IAAI;AACR;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,gCAAgC;;QAEhC,4BAA4B;IAChC;;IAEA;QACI,aAAa;IACjB;;IAEA,6BAA6B;IAC7B,qBAAqB;IACrB,IAAI;AACR;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA,6BAA6B;IAC7B,qBAAqB;IACrB,IAAI;AACR;;AAEA;IACI;QACI,gBAAgB;QAChB,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA,6BAA6B;IAC7B,qBAAqB;IACrB,IAAI;AACR;;AAEA;IACI;QACI,eAAe;QACf,oBAAoB;IACxB;AACJ;;AAEA,8BAA8B;AAC9B;IACI,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;;AAGA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,aAAa;AACb,iBAAiB;AACjB,oBAAoB;AACpB,IAAI;;AAEJ;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,MAAM;IACN,cAAc;IACd,OAAO;IACP,iBAAiB;IACjB,WAAW;IACX,8BAA8B;IAC9B,gBAAgB;IAChB,UAAU;IACV,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;AACnB;;AAEA,qBAAqB;;;AAGrB;;IAEI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,uCAAgE;IAChE,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,wCAAiE;IACjE,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB","sourcesContent":["/******************************************************************************/\n/* New Dashboard */\n\n.column-area {\n    margin: 25px 0;\n}\n\n/*@media (max-width: 1024px) {*/\n/*    .column-area {*/\n/*        max-width: 100%*/\n/*    }*/\n/*}*/\n\n.column-area .cart {\n    background: #ffffff;\n    border: 1px solid #f8f8f8;\n    border-radius: 8px;\n    padding: 0 20px 30px 20px;\n    text-align: center;\n    height: 100%;\n}\n\n.column-area .cart .cart-inner {\n    height: 132px;\n    display: flex;\n    align-items: flex-end;\n    justify-content: center;\n}\n\n.column-area .cart .cart-inner svg {\n    position: absolute;\n    top: -32px;\n    right: -13px;\n}\n\n.column-area .cart h6 {\n    /*font-weight: 700;*/\n    font-weight: 400;\n    font-size: 16px;\n    text-align: center;\n    color: #0f062b;\n    margin-top: 15px;\n}\n\n.column-area .cart a.goto {\n    font-weight: 700;\n    font-size: 16px;\n    /*color: #7a2df9;*/\n    color: #878395;\n    text-decoration: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    width: fit-content;\n    margin: 15px auto 0;\n}\n\n.column-area .cart a.goto span {\n    font-size: 17px;\n    padding-top: 1px;\n}\n\n.column-area .cat-main {\n    text-align: center;\n    height: 100%;\n}\n\n.column-area .cat-main img {\n    position: relative;\n    z-index: 1;\n    /* bottom: -20px; */\n}\n\n.column-area .cat-main .cat-text {\n    background: #ffffff;\n    border: 1px solid #f8f8f8;\n    /*box-shadow: 0 4px 22px rgba(171, 171, 171, 0.25);*/\n    border-radius: 9px;\n    padding: 30px 20px 20px 20px;\n    position: relative;\n    top: -20px;\n}\n\n.column-area .cat-main .cat-text h6 {\n    font-weight: 400;\n    /*font-size: 20px;*/\n    font-size: 14px;\n    text-align: center;\n    color: #0f062b;\n}\n\n.profile-cursor {\n    cursor: pointer;\n}\n\n.column-area .cat-main .cat-text .btn-area {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 15px;\n    margin-top: 15px;\n}\n\n.column-area .cat-main .cat-text .btn-area button {\n    border: none;\n    font-weight: 400;\n    /*font-size: 18px;*/\n    font-size: 14px;\n    color: #878395;\n    padding: 2px 8px;\n    background-color: transparent;\n    transition: 0.5s;\n}\n\n.column-area .cat-main .cat-text .btn-area button.active,\n.column-area .cat-main .cat-text .btn-area button:hover {\n    color: #6c2fbb;\n}\n\n.column-area .myvideo {\n    font-weight: 700;\n    font-size: 28px;\n    color: #0f062b;\n    padding: 5px 0 20px;\n    margin-bottom: 0;\n}\n\n.column-area .profiles-area .tabs-main {\n    background: #ffffff;\n    border: 1px solid #f8f8f8;\n    border-radius: 16px;\n    padding: 15px;\n}\n\n.column-area .myvideo {\n    font-weight: 700;\n    font-size: 28px;\n    color: #0f062b;\n    padding: 5px 0 20px;\n    margin-bottom: 0;\n}\n\n.tab-menu ul {\n    margin: 0 0 5px 0;\n    padding: 0;\n    list-style: none;\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    overflow-x: auto;\n    white-space: nowrap;\n}\n\n.tab-menu ul::-webkit-scrollbar {\n    height: 7px;\n}\n\n.tab-menu ul li a {\n    text-decoration: none;\n    font-weight: 500;\n    font-size: 20px;\n    color: #878395;\n    padding: 9px 0;\n    /* border-radius: 4px; */\n}\n\n.tab-menu ul li {\n    margin-bottom: 5px;\n    margin-right: 20px;\n    padding: 10px 0;\n}\n\n.tab-menu ul li a.active-a {\n    color: #6c2fbb;\n    position: relative;\n    border-top: 3px solid rgba(108, 47, 187, 1);\n    padding: 9px 0;\n}\n\n/* .tab-menu ul li a.active-a::before {\n  position: absolute;\n  bottom: -5px;\n  left: 50%;\n  transform: translateX(-50%);\n  content: \"\";\n  width: 100%;\n  height: 3px;\n  background: #6c2fbb;\n  border-radius: 6px;\n} */\n\n/*.tab {*/\n/*display: none;*/\n/*}*/\n\n.FF-scroll-modify {\n    /*max-height: calc(100vh - 580px) !important;*/\n    height: 100% !important;\n    overflow-x: hidden;\n    overflow-y: scroll;\n    margin-top: 20px;\n}\n\n.FF-scroll-modify-h {\n    /*max-height: calc(100vh - 290px) !important;*/\n    height: 100% !important;\n}\n\n.view-all {\n    text-align: right;\n    margin-top: -2rem;\n}\n\n.no-videos {\n    text-align: center;\n    margin-top: 15vh;\n}\n\n.tab .cartina img {\n    /*border-radius: 8px;*/\n    height: 100%;\n    /*width: 100%;*/\n}\n\n.tab .cartina .img-box img {\n    /*object-fit: cover;*/\n    object-fit: fill;\n}\n\n.tab .cartina .img-box {\n    overflow: hidden;\n    border-radius: 10px;\n    max-width: 490px;\n    width: 100%;\n    height: 260px;\n    text-align: center;\n    position: relative;\n}\n\n/*.tab .cartina .badge-box {*/\n/*    height: 190px;*/\n/*}*/\n\n.tab .cartina h3 {\n    /*font-weight: 700;\n      font-size: 20px;*/\n    font-weight: 500;\n    font-size: 16px;\n    color: #0f062b;\n    margin: 10px 0 1px 0;\n}\n\n.tab .cartina p {\n    font-weight: 400;\n    font-size: 14px;\n    color: #878395;\n    margin-bottom: 0;\n}\n\n/*.tab-active {*/\n/*    display: block;*/\n/*}*/\n\n.profile-box-main {\n    background: #ffffff;\n    border: 1px solid #f8f8f8;\n    border-radius: 16px;\n    padding: 25px;\n    text-align: center;\n    height: 100%;\n}\n\n.profile-box-main .box {\n    position: relative;\n    width: fit-content;\n    margin: auto;\n    border-radius: 13px;\n}\n\n.profile-box-main .box .prof {\n    border-radius: 13px;\n    width: 82px;\n    height: 82px;\n    object-fit: cover;\n}\n\n.profile-image {\n    width: 84px;\n    height: 84px;\n    text-align: center;\n    color: #ffffff;\n    background: #bd50d0;\n    border-radius: 16px;\n    /*display: inline-block;*/\n    font-size: 36px;\n    font-weight: 600;\n    vertical-align: middle;\n    text-transform: uppercase;\n    line-height: 1.7;\n}\n\n.profile-box-main .box .edit {\n    position: absolute;\n    bottom: -1px;\n    right: -12px;\n    content: \"\";\n    width: 27px;\n    height: 27px;\n    background: transparent;\n    border-radius: 6px;\n    border: none;\n    overflow: hidden;\n    padding: 0;\n}\n\n.profile-box-main h4 {\n    font-weight: 500;\n    font-size: 16px;\n    color: #0f062b;\n    margin-top: 20px;\n}\n\n.profile-box-main .word {\n    font-weight: 400;\n    font-size: 14px;\n    color: #595469;\n    margin-top: 16px;\n    /*line-break: anywhere;*/\n    word-break: break-word;\n}\n\n.profile-box-main .ul {\n    gap: 35px;\n    margin-top: 30px;\n    /*flex-wrap: wrap;*/\n}\n\n.profile-box-main .ul h3 {\n    font-weight: 700;\n    font-size: 24px;\n    color: #0f062b;\n    margin-bottom: 0;\n}\n\n.profile-box-main .ul p {\n    font-weight: 500;\n    font-size: 14px;\n    color: #878395;\n    margin-bottom: 0;\n}\n\n.profile-box-main .profile-count:hover p {\n    text-decoration: underline;\n}\n\n.profile-box-main .btn-mania {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-wrap: wrap;\n    gap: 10px;\n    max-width: 360px;\n    margin: 30px auto 0;\n}\n\n/*.profile-box-main .btn-mania button {\n  font-weight: 500;\n  font-size: 12px;\n  color: #6c2fbb;;\n  border: 0.5px solid #6c2fbb;\n  background: #FFFFFF;\n  padding: 4px 12px;\n  border-radius: 12px;\n  white-space: nowrap;\n}*/\n\n.profile-box-main .btn-mania button {\n    color: #6c2fbb;\n    border: 1px solid #6c2fbb;\n    padding: 4px 12px;\n    font-size: 12px;\n    font-weight: 500;\n    background: #FFFFFF;\n    border-radius: 11px;\n    /*margin: 5px 7px;*/\n    white-space: nowrap;\n}\n\n/*\n.profile-box-main .btn-mania button:nth-child(4n+1) {\n  background-color: #f92d82;\n}\n.profile-box-main .btn-mania button:nth-child(4n+2) {\n  background-color: #f99b2d;\n}\n.profile-box-main .btn-mania button:nth-child(4n+3) {\n  background-color: #11d200;\n}\n.profile-box-main .btn-mania button:nth-child(4n+4) {\n  background-color: #2f50ff;\n}\n*/\n\n.profile-box-main .last-p {\n    font-weight: 400;\n    font-size: 14px;\n    color: #0f062b;\n    margin-top: 10px;\n    margin-bottom: 0;\n}\n\n@media (max-width: 1800px) {\n    .column-area .cart h6 {\n        font-size: 16px;\n    }\n\n    .column-area .cart {\n        padding: 0 10px 20px 10px;\n    }\n\n    .column-area .cat-main .cat-text h6 {\n        font-size: 14px;\n    }\n\n    .column-area .cat-main .cat-text .btn-area button {\n        /*font-size: 17px;*/\n        font-size: 14px;\n    }\n\n    .column-area .cat-main .cat-text {\n        padding: 20px;\n    }\n\n    .column-area .cat-main .cat-text .btn-area {\n        margin-top: 10px;\n    }\n\n    .tab .cartina .img-box {\n        height: 230px;\n    }\n    /*.tab .cartina .badge-box {*/\n    /*    height: 180px;*/\n    /*}*/\n}\n\n@media (max-width: 1600px) {\n    .column-area .cart h6 {\n        font-size: 18px;\n    }\n\n    .column-area .cat-main .cat-text {\n        /*padding: 20px 20px 15px 20px;*/\n\n        padding: 30px 20px 15px 20px;\n    }\n\n    .tab .cartina .img-box {\n        height: 200px;\n    }\n\n    /*.tab .cartina .badge-box {*/\n    /*    height: 160px;*/\n    /*}*/\n}\n\n@media (max-width: 1500px) {\n    .tab .cartina .img-box {\n        height: 200px;\n    }\n\n    .tab .cartina .img-box {\n        height: 160px;\n    }\n\n    .column-area .cart h6 {\n        font-size: 18px;\n    }\n\n    .column-area .cart a.goto {\n        font-size: 15px;\n    }\n\n    .tab-menu ul li a.active-a {\n        font-size: 18px;\n    }\n\n    .tab-menu ul li a {\n        font-size: 18px;\n    }\n}\n\n@media (max-width: 1300px) {\n    .profile-box-main .ul {\n        gap: 20px;\n    }\n\n    .profile-box-main .ul h3 {\n        font-size: 22px;\n    }\n\n    .tab .cartina .img-box {\n        height: 180px;\n    }\n\n    /*.tab .cartina .badge-box {*/\n    /*    height: 140px;*/\n    /*}*/\n}\n\n@media (max-width: 991px) {\n    .tab-menu ul {\n        margin-bottom: 0;\n        gap: 10px;\n    }\n\n    .tab .cartina .img-box {\n        height: 230px;\n    }\n\n    .tab .cartina .badgebadgeba-box-box {\n        height: 180px;\n    }\n}\n\n@media (max-width: 768px) {\n    .profile-box-main .btn-mania {\n        margin: 20px auto 0;\n    }\n}\n\n@media (max-width: 425px) {\n    .column-area .myvideo {\n        font-size: 28px;\n        padding: 19px 0;\n        margin-bottom: 0;\n    }\n\n    .profile-box-main .ul {\n        margin-top: 20px;\n    }\n\n    .tab .cartina .img-box {\n        height: 192px;\n    }\n\n    /*.tab .cartina .badge-box {*/\n    /*    height: 152px;*/\n    /*}*/\n}\n\n@media (max-width: 320px) {\n    .tab .cartina h3 {\n        font-size: 19px;\n        margin: 12px 0 0px 0;\n    }\n}\n\n/*****************************/\n.img-poster {\n    width: 100%;\n    /*margin-top: 10px;*/\n}\n\n.slises {\n    margin-top: 10px;\n    font-size: 14px;\n    color: #9e9e9e;\n}\n\n\n.dottype {\n    display: inline-block;\n    position: absolute;\n    left: 0;\n    top: 5px;\n    width: 7px;\n    height: 7px;\n    border-radius: 50%;\n    /*margin-right: 0;*/\n    background: #000;\n    vertical-align: middle;\n    margin-right: 5px;\n    font-weight: 600;\n}\n\n.upli.upli0 {\n    font-weight: bold;\n}\n\n/*.tbalesa {*/\n/*  width: 100%;*/\n/*  display: table;*/\n/*}*/\n\n.dottype.dottype0 {\n    background: #A649C7;\n}\n\n.dottype.dottype1 {\n    background: #EFB43A;\n}\n\n.dottype.dottype2 {\n    background: #3DC99C;\n}\n\n.dottype.dottype3 {\n    background: #DB6A8E;\n}\n\n.v-choice-info ul li {\n    list-style-type: none;\n    font-size: 13px;\n    position: relative;\n    /*background: #f4f7f6;*/\n}\n\n.v-choice-info ul li p {\n    margin: 0px 10px;\n}\n\n\np.main-title {\n    color: #fff !important;\n    position: absolute;\n    /*top: 10px;*/\n    top: 0;\n    /*left: 10px;*/\n    left: 0;\n    text-align: start;\n    width: 100%;\n    background: rgba(0, 0, 0, 0.5);\n    padding: 3px 8px;\n    z-index: 9;\n    font-weight: 400 !important;\n    font-size: 14px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.view-all a {\n    color: #6c2fbb !important;\n    font-weight: 500;\n    font-size: 12px;\n}\n\n/********************/\n\n\n.slider .owl-nav button.owl-next,\n.slider .owl-nav button.owl-prev {\n    padding: 0px 8px !important;\n}\n\n.slider > .owl-nav button:first-child {\n    left: -15px;\n}\n\n.slider > .owl-nav button:last-child {\n    right: -15px;\n}\n\n.v-choice-info {\n    padding-top: 12px;\n}\n\n.slider .v-choice-info .lr-arrow a {\n    position: unset;\n    opacity: 1;\n    border: 2px solid #727272;\n    width: 20px;\n    height: 20px;\n    border-radius: 2px;\n}\n\n.slider .v-choice-info .lr-arrow {\n    float: right;\n    display: flex;\n    justify-content: space-between;\n    width: 45px;\n}\n\n.v-choice-info .carousel-control-prev-icon {\n    background-image: url('./../../../assets/images/left-arrow.svg');\n    width: 12px;\n    height: 12px;\n}\n\n.v-choice-info .carousel-control-next-icon {\n    background-image: url('./../../../assets/images/right-arrow.svg');\n    width: 12px;\n    height: 12px;\n}\n\n.v-choice-info .media img {\n    width: 40px;\n    height: 40px;\n}\n\n.hb-film-sec-4 .v-choice-info ul {\n    padding-left: 0px;\n    margin-bottom: 0;\n}\n\n.hb-film-sec-4 .v-choice-info ul li {\n    list-style-type: none;\n    font-size: 13px;\n    background: #f4f7f6;\n}\n\n.tbalesa3 {\n    padding: 10px !important;\n    background: #f4f7f6;\n    z-index: 9;\n    margin-left: 65px;\n}\n\n.v-choice-info > span {\n    color: #929090;\n    font-size: 14px;\n}\n\n.v-choice-info .media .media-body > h6 {\n    margin-bottom: 0px;\n    font-size: 15px;\n}\n\n.slider .carousel-indicators .active {\n    background-color: #6c2fbb;\n}\n\n.slider .carousel-caption {\n    text-align: left;\n    left: 0px;\n    top: 0px;\n    padding-top: 10px;\n    padding-left: 13px;\n    font-size: 14px;\n    font-weight: 600;\n}\n\n.slider .v-choice-info ul li samp {\n    margin-right: 2px;\n    margin-left: 3px;\n}\n\n.btn-holder {\n    /*float: right;*/\n    /*width: auto;*/\n    background-color: #FFF;\n    color: #6c2fbb;\n    border: 1px solid #6c2fbb;\n    border-radius: 5px;\n    padding: 2px 10px;\n}\n\n.btn-holder.follow {\n    background-color: #6c2fbb;\n    color: #fff;\n    border: 1px solid #fff;\n}\n\n.over {\n    right: 34px !important;\n}\n\n.Popular {\n    background: #e1e1f9;\n    border-radius: 20px;\n    border: none;\n    outline: none;\n    color: #6438b4;\n    padding: 5px 15px;\n    margin: 0 10px;\n    font-weight: bold;\n    font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
